/* global google */
import React, { Component } from 'react';
import styled from 'styled-components';
import { MobileLocationSearchInput } from '../LocationInput';
import { trackEvent } from '../../utils/analytics';

const List = styled.div`
  width: 100%;
  height: 300px;
  margin: 1.5em auto;
  border: 1px solid #ced4da;
  border-radius: 4px;
  -webkit-box-shadow: 0 0.25rem 0.25rem -0.25rem rgba(0, 0, 0, 0.075) !important;
  box-shadow: 0 0.25rem 0.25rem -0.25rem rgba(0, 0, 0, 0.075) !important;
  padding: 0.5em 0.5em 1em 0.5em;
  overflow-y: auto;
  overflow-x: hidden;
`;

const ListItem = styled.div`
  -webkit-box-shadow: 0 0.25rem 0.25rem -0.25rem rgba(0, 0, 0, 0.075) !important;
  box-shadow: 0 0.25rem 0.25rem -0.25rem rgba(0, 0, 0, 0.075) !important;
  padding: 0.5em 0.5em 1em 0.5em;

  ${props => props.active && `
    background-color: hsl(0, 0%, 29%);
    color: #FFFFFF;
  `}
`;

const Placeholder = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 350px;
`;

const Section = styled.section`
  overflow-x: hidden;
`;

class LocationSearch extends Component {
  state = {
    locations: null,
    searching: false,
    destination: null,
  };

  handleChange = (suggest) => {
    if (suggest !== '') {
      this.setState({ searching: true });
    } else {
      this.setState({ locations: [], searching: false });
    }
  }

  updateList = (locations) => {
    if (!this.state.searching) return;
    this.setState({ locations });
  }

  selectAddress = (location) => {
    const geocoder = new google.maps.Geocoder();
    
    geocoder.geocode({ address: location.label }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        const [value] = results;

        const { lat } = value.geometry.location;
        const { lng } = value.geometry.location;

        const [address] = location.label.split(',');

        this.setState({
          destination: {
            lat: lat(),
            lng: lng(),
            address,
            formattedAddress: location.description,
          }
        });

        trackEvent('users', 'set location', location.description);
      }
    });
  }

  render() {
    const { locations, destination } = this.state;
    const { setDeliveryAddress, maps, close } = this.props;
    return (
      <Section className='section mt-3 is-hidden-desktop'>
        <h3 className='subtitle has-text-weight-semibold'>
          Delivery details <br />
          <small className='has-text-grey'>{destination ? destination.address : (maps.location || {}).address}</small>
        </h3>
        <MobileLocationSearchInput
          google={typeof window.google !== 'undefined' && new window.google.maps.LatLng(-26.195246, 28.034088)}
          onChange={suggest => this.handleChange(suggest)}
          onUpdateSuggests={locations => this.updateList(locations)}
        />
        {!locations && <Placeholder>
          <p className='has-text-grey has-text-weight-semibold'>Where would you like us to deliver?</p>
        </Placeholder>}
        {locations && <List>
          {locations.map(location => (
            <ListItem
              active={location.description === (destination || {}).formattedAddress}
              key={location.placeId}
              onClick={() => this.selectAddress(location)}
            >
              <p className='has-text-weight-semibold'>
                {location.label.split(',')[0]} <br />
                <small className='has-text-grey'>{location.description}</small>
              </p>
            </ListItem>
          ))}
        </List>}
        {destination &&
          <button className='button is-primary is-fullwidth'
            onClick={() => {
              setDeliveryAddress(destination);
              close();
            }}
          >
            Done
          </button>}
        {locations && <button className='button is-light is-fullwidth mt-1' onClick={() => close()}>Cancel</button>}
      </Section>
    );
  }
}

export default LocationSearch;